import {Component, Input, OnInit} from '@angular/core';
import {SafeStyle} from '@angular/platform-browser';

@Component({
  selector: 'w-multi-column-field',
  templateUrl: './multi-column-field.component.html',
  styleUrls: ['./multi-column-field.component.scss']
})
export class MultiColumnFieldComponent implements OnInit {
  @Input() widthSplits: string[] = [];
  @Input() isLabel: boolean[] = [];
  styles: SafeStyle[];

  constructor() { }

  ngOnInit(): void {
    this.styles = [];
    for (const width of this.widthSplits) {
      this.styles.push(`width: ${width}`);
    }
    for (let i = this.styles.length; i < 10; i++) {
      this.styles.push('');
    }
  }

}
